module.exports = __webpack_public_path__ + "img/neo-bg.04808c2f.png";